import { LinkedinTypes } from 'enums';
import { LinkedinAccount } from '../linkedin-accounts/linkedin-accounts.types';

export interface Tasks {
  fixAccounts?: LinkedinAccount[];
  fixAccountsCount?: number;
  approveContacts?: TmContactApprovalTask[];
  approveContactsCount?: number;
  approveMessages?: TmMessageApprovalTask[];
  approveMessagesCount?: number;
  replyMessages?: TmMessageReplyTask[];
  replyMessagesCount?: number;
  totalCount?: number;
}

export interface TmMessageApprovalTask {
  funnelId: string;
  funnelName: string;
  linkedinAccount?: {
    _id: string;
    userEmail: string;
    firstName: string;
    lastName: string;
    liProductType: LinkedinTypes;
  };
  toBeApprovedMessages: number;
}

/** Kampagne mit Kontakten, die vor der ersten Ansprache auf Freigabe warten. */
export type TmContactApprovalTask = Omit<TmMessageApprovalTask, 'toBeApprovedMessages'> & { toBeApprovedContacts: number };

export interface TmMessageReplyTask {
  funnelId: string;
  funnelName: string;
  linkedinAccount?: {
    _id: string;
    userEmail: string;
    firstName: string;
    lastName: string;
    liProductType: LinkedinTypes;
  };
  unreadMessagesCount: number;
}

export enum Tabs {
  ALL = 'all',
  FIX_ACCOUNTS = 'fixAccounts',
  APPROVE_MESSAGES = 'approveMessages',
  REPLY_MESSAGES = 'replyMessages'
}
